import { Component, OnInit, ChangeDetectionStrategy, Inject, Output, EventEmitter, SecurityContext, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'lgv-confirmation-dialog',
    templateUrl: 'confirmation-dialog.component.html',
    styleUrls: ['confirmation-dialog.component.scss']
})

export class ConfirmationDialogComponent implements OnDestroy {

    @Output() OnOKClicked: EventEmitter<string> = new EventEmitter();

    @ViewChild('dialogContent') dialogContent!: ElementRef

    ConfirmationHTML: SafeHtml;
    headerHTML: SafeHtml;

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        private Sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cdr: ChangeDetectorRef
    ) {
        dialogRef.disableClose = true;
        this.ConfirmationHTML = this.Sanitizer.sanitize(SecurityContext.HTML, this.data.Confirmation);
        this.headerHTML = this.Sanitizer.sanitize(SecurityContext.HTML, this.data?.header);
    }

    ngAfterViewInit(): void {
        this.waitForLayoutAndScrollTop();
    }

    OnCancel(): void {
        this.dialogRef.close({ action: false });
    }

    OnOK() {
        this.OnOKClicked.emit("");
        this.dialogRef.close({ action: true });
    }

    ngOnDestroy(): void {
        this.data = null;
    }

    private waitForLayoutAndScrollTop(attempt: number = 0): void {
        if (attempt >= 10) return;

        setTimeout(() => {
            const el = this.dialogContent?.nativeElement;

            if (el && el.scrollTop !== 0) {
                el.scrollTop = 0;
            } else {
                this.waitForLayoutAndScrollTop(attempt + 1);
            }
        }, 50);
    }

}
